import { AuthenticationService } from '../authentication.service';
import { decodePayload } from '../../../helpers/jwt';
import { getAuthenUrl } from '../authentication.utils';
import { HTTP_SERVICE, IHttpError, IHttpService } from '../../http';
import { IAuthenticationService, ILoginResponse } from '../authentication.interface';
import { IAuthenticationTokens, IError, IJWT } from '../../../interfaces';
import { inject, injectable } from 'inversify';
import { USER_01 } from '../../../mocks/user.data';

@injectable()
export class PortalAuthenticationService extends AuthenticationService implements IAuthenticationService {

    @inject(HTTP_SERVICE) private readonly httpSrv: IHttpService;

    login(): Promise<[ IJWT, IError? ]> {
        /**
         * NOTE: When login with the banking portal, we need to provide empty credentials.
         * The cookies will be used to authentify the user.
         */
        const body = {
            user: '',
            password: '',
        };
        const cookieAuth = {
            credentials: 'include',
        };

        return this.httpSrv.post<ILoginResponse>(getAuthenUrl(), body, cookieAuth)
            .then(([ data, error ]: [ ILoginResponse, IHttpError ]) => {
                if (Boolean(error)) {
                    return [ undefined, {
                        type: 'Technical',
                        code: error.code,
                        message: error.message,
                    } ];
                } else if (Boolean(data.error)) {
                    return [ undefined, {
                        type: 'Functional',
                        message: data.error,
                    } ];
                }

                /**
                 * When using the SSO authentication workflow, `userId` will be always undefined
                 * if thats the case we need to parse the token and get the userId from the tokens
                 * payload `sub` key.
                 *
                 * Also, if we are in SSO the users type is `corporate`. Otherwise the user is `bank`.
                 * Knowing this is needed for kondor blotter SSE api.
                 */
                const { sub } = decodePayload(data.token);
                const user = {
                    // TODO: Why do we mix user data with mocked data ???
                    ...USER_01,
                    id: sub as string,
                    userType: 'corporate',
                };

                const tokens: IAuthenticationTokens = {
                    user_id: user.id,
                    token_type: 'token',
                    access_token: data.token,
                };
                sessionStorage.setItem('SFX_IS_LOGGED', 'true');
                sessionStorage.setItem('SFX_TOKENS', JSON.stringify(tokens));
                sessionStorage.setItem('USER', JSON.stringify(user));
                sessionStorage.setItem('SFX_AUTH_MODE', 'portal');

                return [ data.token ];
            });
    }
}
